(function () {
    'use strict';

    angular
        .module('app')
        .controller('index', index);

    index.$inject = ['sidebarservice', '$window', '$location', 'loginService', '$rootScope']; 

    function index(sidebarservice, $window, $location, loginService, $rootScope) {
        /* jshint validthis:true */
        var vm = this;
        vm.title = 'index';
        vm.sidebarservice = sidebarservice;
        activate();
        vm.height = $window.height;
        vm.window = $window;

        vm.loginService = loginService;
        //console.log("index loaded");

        loginService.checkOauthEnabled();

        function activate() { }
    }
})();
